export type InterfaceLanguage = 'fr' | 'en';

const STORAGE_KEY = 'interfaceLanguage';

const translations = {
    fr: {
        'tabs.streamers': 'Afficher et ajouter des streamers',
        'app.title': 'MultiStream — Regardez plusieurs streams simultanément',
        'tabs.chat': 'Chat',
        'tabs.settings': 'Paramètres',
        'sidebar.toggle': 'Réduire ou ouvrir la sidebar',
        'sidebar.home': 'Revenir à l’accueil',
        'sidebar.resumeStreams': 'Revenir aux streams',
        'chat.global': 'Global',
        'chat.individual': 'Individuel',
        'search.placeholder': 'Rechercher des streamers…',
        'search.add': 'Ajouter le streamer',
        'options.layout': 'Disposition',
        'options.grid': 'Grille :',
        'options.auto': 'Automatique',
        'options.language': 'Langue de l’interface',
        'options.languageLabel': 'Langue :',
        'options.french': 'Français',
        'options.english': 'English',
        'options.combos': 'Combinaisons de streams',
        'options.manageCombos': 'Gérer mes combinaisons',
        'combos.manage': 'Gérer les combinaisons',
        'combos.manageHint': 'Retrouvez et lancez vos sélections en un clic.',
        'combos.mine': 'Mes combinaisons',
        'combos.mineHint': 'Vos sélections enregistrées sur cet appareil.',
        'combos.featured': 'Combinaisons populaires',
        'combos.public': 'Presets publics',
        'combos.publicHint': 'Des sélections prêtes à lancer.',
        'combos.editorHint': 'Nommez votre sélection et choisissez ses streamers.',
        'combos.importExport': 'Importer / Exporter',
        'combos.create': 'Créer une combinaison',
        'combos.export': 'Exporter les combinaisons',
        'combos.exportHelp': 'Exportez vos combinaisons personnalisées pour les partager ou les sauvegarder.',
        'combos.exportJson': 'Exporter en JSON',
        'combos.import': 'Importer des combinaisons',
        'combos.importHelp': 'Importez des combinaisons depuis un fichier JSON.',
        'combos.importJson': 'Importer depuis JSON',
        'combos.name': 'Nom de la combinaison :',
        'combos.namePlaceholder': 'Ma combinaison',
        'combos.description': 'Description (facultative) :',
        'combos.descriptionPlaceholder': 'Une courte description de cette combinaison',
        'combos.language': 'Langue :',
        'combos.category': 'Catégorie :',
        'combos.streamers': 'Streamers :',
        'combos.streamerPlaceholder': 'Pseudo du streamer',
        'combos.addStreamer': 'Ajouter un streamer',
        'combos.save': 'Enregistrer',
        'combos.edit': 'Modifier la combinaison',
        'combos.update': 'Mettre à jour',
        'combos.load': 'Charger',
        'combos.empty': 'Vous n’avez encore créé aucune combinaison.',
        'combos.emptyHint': 'Créez votre première combinaison pour sauvegarder vos streamers préférés !',
        'combos.noDescription': 'Aucune description',
        'combos.noMatch': 'Aucune combinaison ne correspond à vos filtres.',
        'combos.noMatchHint': 'Essayez de modifier les critères de filtrage.',
        'combos.nameRequired': 'Saisissez un nom pour la combinaison.',
        'combos.streamerRequired': 'Ajoutez au moins un streamer à la combinaison.',
        'combos.updated': 'Combinaison « {name} » mise à jour.',
        'combos.created': 'Combinaison « {name} » créée.',
        'combos.clearConfirm': 'Voulez-vous retirer les streams actuels avant de charger cette combinaison ?',
        'combos.loading': 'Chargement de la combinaison : {name}',
        'combos.none': 'Aucun streamer valide dans cette combinaison.',
        'combos.loaded': '{count} streamers chargés depuis « {name} »',
        'combos.loadError': 'Erreur lors du chargement de la combinaison : {message}',
        'combos.deleteConfirm': 'Voulez-vous vraiment supprimer cette combinaison ?',
        'combos.deleted': 'Combinaison « {name} » supprimée',
        'combos.noneToExport': 'Aucune combinaison à exporter.',
        'combos.exported': 'Combinaisons exportées.',
        'combos.imported': '{count} combinaisons importées.',
        'combos.readError': 'Erreur lors de la lecture du fichier.',
        'combos.storageError': 'Erreur lors de l’enregistrement local des combinaisons.',
        'combos.quickMenu': 'Accès rapide aux combinaisons',
        'combos.quickTitle': 'Mes combinaisons',
        'combos.searchPreset': 'Rechercher un preset…',
        'combos.createShort': 'Créer',
        'combos.saveCurrent': 'Sauvegarder l’actuel',
        'combos.quickEmpty': 'Aucun preset sauvegardé. Créez-en un avec les streams actuels.',
        'combos.noSearchResult': 'Aucun preset ne correspond à cette recherche.',
        'combos.streamerCount': '{count} streamer(s)',
        'filters.allLanguages': 'Toutes les langues',
        'filters.allCategories': 'Toutes les catégories',
        'filters.language': 'Filtrer par langue',
        'filters.category': 'Filtrer par catégorie',
        'filters.charitable': 'Caritatif',
        'filters.gaming': 'Gaming',
        'filters.esports': 'Esport',
        'filters.talk': 'Talk-shows',
        'filters.music': 'Musique',
        'filters.other': 'Autre',
        'language.en': 'Anglais',
        'language.fr': 'Français',
        'language.es': 'Espagnol',
        'language.de': 'Allemand',
        'chat.globalEnabled': 'Chat global activé',
        'chat.globalDescription': 'Vous voyez les messages de tous les streamers en live :',
        'chat.realtime': 'Les messages apparaîtront ici en temps réel !',
        'chat.activeStreamers': 'Streamers actifs :',
        'chat.noLiveForGlobal': 'Aucun streamer en live pour le chat global',
        'common.close': 'Fermer',
        'common.remove': 'Retirer',
        'common.loading': 'Chargement…',
        'common.error': 'Erreur : {message}',
        'stream.chat': 'Afficher le chat dédié',
        'stream.focus': 'Mettre au focus',
        'stream.leaveFocus': 'Quitter le focus',
        'stream.maximize': 'Maximiser',
        'stream.restore': 'Restaurer tous les players',
        'stream.latency': 'Régler la latence',
        'stream.waiting': 'En attente',
        'stream.queue': 'File d’attente · {count}',
        'stream.spectators': '{count} spectateurs',
        'stream.added': '{name} a été ajouté aux streams',
        'stream.queued': '{name} a été ajouté à la file d’attente',
        'stream.alreadyAdded': '{name} est déjà dans votre liste',
        'stream.removed': '{name} a été retiré',
        'stream.live': '{name} est maintenant en live !',
        'stream.offline': '{name} est hors ligne et retourne dans la file d’attente.',
        'stream.searching': 'Recherche…',
        'stream.noResults': 'Aucun streamer trouvé',
        'stream.offlineSearch': 'Hors ligne · ajouter à la file d’attente',
        'stream.reordered': 'Disposition des streamers mise à jour',
        'stream.loadError': 'Erreur lors du chargement des streamers',
        'stream.addError': 'Impossible d’ajouter le streamer. Réessayez.',
        'stream.retrieveError': 'Impossible de récupérer ce streamer',
        'stream.removeError': 'Impossible de retirer le streamer',
        'audio.muted': 'Muet',
        'audio.mute': 'Couper le son',
        'audio.unmute': 'Réactiver le son',
        'audio.lower': 'Baisser le volume',
        'audio.raise': 'Augmenter le volume',
        'mini.actions': 'Actions pour {name}',
        'chat.welcome': 'Bienvenue dans le chat MultiStream',
        'chat.noLive': 'Aucun streamer n’est actuellement en live.',
        'chat.addHint': 'Ajoutez des streamers pour voir leurs chats s’afficher ici !',
        'chat.clickHint': 'Cliquez sur l’icône de chat à côté d’un streamer pour afficher son chat.',
        'chat.individualMode': 'Mode Chat Individuel',
        'chat.globalHint': 'Vous pouvez basculer vers le chat global avec l’icône planète de la sidebar.',
        'welcome.title': 'Bienvenue sur MultiStream',
        'welcome.eyebrow': 'Votre espace Twitch, réuni',
        'welcome.heroTitle': 'Tous vos lives.',
        'welcome.heroAccent': 'Un seul écran.',
        'welcome.fast': 'Démarrage progressif',
        'welcome.shareable': 'Disposition partageable',
        'welcome.flexible': 'Contrôles indépendants',
        'welcome.live': 'Prêt à regarder',
        'welcome.audioTitle': 'Audio maîtrisé',
        'welcome.audioText': 'Basculez instantanément le son et le focus entre vos lives.',
        'welcome.subtitle': 'Regardez plusieurs streams Twitch simultanément dans une disposition personnalisable',
        'welcome.multipleTitle': 'Streams multiples',
        'welcome.multipleText': 'Regardez vos streamers préférés simultanément dans une grille personnalisable.',
        'welcome.shareTitle': 'Partage facile',
        'welcome.shareText': 'Partagez votre disposition de streams avec une simple URL.',
        'welcome.combosTitle': 'Combinaisons de streams',
        'welcome.combosText': 'Créez, sauvegardez et chargez vos combinaisons préférées.',
        'welcome.search': 'Rechercher un streamer',
        'welcome.resume': 'Reprendre les streams',
        'welcome.browse': 'Parcourir les combinaisons',
        'welcome.discord': 'Rejoindre Discord',
        'welcome.featured': 'Combinaisons populaires',
        'welcome.yours': 'Vos combinaisons',
        'welcome.manage': 'Gérer',
        'welcome.sidebarIntro': 'Recherchez un streamer Twitch ci-dessus pour l’ajouter à votre disposition.',
        'welcome.sidebarShare': 'Regardez plusieurs streamers simultanément et partagez facilement votre disposition.',
        'welcome.examples': 'Exemples d’URL :',
        'welcome.noCombos': 'Vous n’avez encore créé aucune combinaison de streams.',
        'welcome.createFirst': 'Créer votre première combinaison',
        'latency.title': 'Ajuster la latence du stream',
        'latency.description': 'Configurez un délai personnalisé pour synchroniser ce stream avec les autres.',
        'latency.delay': 'Délai (secondes) :',
        'latency.none': 'Aucun délai',
        'latency.preview': 'Le stream sera retardé de {seconds} secondes',
        'latency.previewPrefix': 'Le stream sera retardé de',
        'latency.seconds': 'secondes',
        'latency.reset': 'Réinitialiser',
        'latency.apply': 'Appliquer',
        'latency.applied': 'Délai de {seconds}s appliqué au stream',
        'latency.removed': 'Délai supprimé du stream',
    },
    en: {
        'tabs.streamers': 'Show and add streamers',
        'app.title': 'MultiStream — Watch multiple streams simultaneously',
        'tabs.chat': 'Chat',
        'tabs.settings': 'Settings',
        'sidebar.toggle': 'Collapse or open sidebar',
        'sidebar.home': 'Return to home',
        'sidebar.resumeStreams': 'Return to streams',
        'chat.global': 'Global',
        'chat.individual': 'Individual',
        'search.placeholder': 'Search streamers…',
        'search.add': 'Add streamer',
        'options.layout': 'Layout',
        'options.grid': 'Grid:',
        'options.auto': 'Auto',
        'options.language': 'Interface language',
        'options.languageLabel': 'Language:',
        'options.french': 'Français',
        'options.english': 'English',
        'options.combos': 'Stream combos',
        'options.manageCombos': 'Manage my combos',
        'combos.manage': 'Manage Stream Combos',
        'combos.manageHint': 'Find and launch your selections in one click.',
        'combos.mine': 'My Combos',
        'combos.mineHint': 'Your selections saved on this device.',
        'combos.featured': 'Featured Combos',
        'combos.public': 'Public presets',
        'combos.publicHint': 'Ready-to-launch selections.',
        'combos.editorHint': 'Name your selection and choose its streamers.',
        'combos.importExport': 'Import / Export',
        'combos.create': 'Create New Combo',
        'combos.export': 'Export Combos',
        'combos.exportHelp': 'Export your custom combos to share or back up.',
        'combos.exportJson': 'Export to JSON',
        'combos.import': 'Import Combos',
        'combos.importHelp': 'Import combos from a JSON file.',
        'combos.importJson': 'Import from JSON',
        'combos.name': 'Combo Name:',
        'combos.namePlaceholder': 'My Awesome Combo',
        'combos.description': 'Description (optional):',
        'combos.descriptionPlaceholder': 'A short description of this combo',
        'combos.language': 'Language:',
        'combos.category': 'Category:',
        'combos.streamers': 'Streamers:',
        'combos.streamerPlaceholder': 'Streamer username',
        'combos.addStreamer': 'Add Streamer',
        'combos.save': 'Save Combo',
        'combos.edit': 'Edit Stream Combo',
        'combos.update': 'Update Combo',
        'combos.load': 'Load',
        'combos.empty': 'You have not created any combos yet.',
        'combos.emptyHint': 'Create your first combo to save your favorite streamers!',
        'combos.noDescription': 'No description',
        'combos.noMatch': 'No combos match your filters.',
        'combos.noMatchHint': 'Try changing your filter criteria.',
        'combos.nameRequired': 'Enter a name for the combo.',
        'combos.streamerRequired': 'Add at least one streamer to the combo.',
        'combos.updated': 'Combo “{name}” updated.',
        'combos.created': 'Combo “{name}” created.',
        'combos.clearConfirm': 'Remove the current streams before loading this combo?',
        'combos.loading': 'Loading combo: {name}',
        'combos.none': 'No valid streamer was found in this combo.',
        'combos.loaded': 'Loaded {count} streamers from “{name}”',
        'combos.loadError': 'Error loading combo: {message}',
        'combos.deleteConfirm': 'Are you sure you want to delete this combo?',
        'combos.deleted': 'Combo “{name}” deleted',
        'combos.noneToExport': 'There are no combos to export.',
        'combos.exported': 'Combos exported.',
        'combos.imported': 'Imported {count} combos.',
        'combos.readError': 'Error reading file.',
        'combos.storageError': 'Error saving combos to local storage.',
        'combos.quickMenu': 'Quick access to stream combos',
        'combos.quickTitle': 'My combos',
        'combos.searchPreset': 'Search presets…',
        'combos.createShort': 'Create',
        'combos.saveCurrent': 'Save current',
        'combos.quickEmpty': 'No saved preset. Create one from your current streams.',
        'combos.noSearchResult': 'No preset matches this search.',
        'combos.streamerCount': '{count} streamer(s)',
        'filters.allLanguages': 'All Languages',
        'filters.allCategories': 'All Categories',
        'filters.language': 'Filter by language',
        'filters.category': 'Filter by category',
        'filters.charitable': 'Charity',
        'filters.gaming': 'Gaming',
        'filters.esports': 'Esports',
        'filters.talk': 'Talk Shows',
        'filters.music': 'Music',
        'filters.other': 'Other',
        'language.en': 'English',
        'language.fr': 'French',
        'language.es': 'Spanish',
        'language.de': 'German',
        'chat.globalEnabled': 'Global chat enabled',
        'chat.globalDescription': 'You are seeing messages from all live streamers:',
        'chat.realtime': 'Messages will appear here in real time!',
        'chat.activeStreamers': 'Active streamers:',
        'chat.noLiveForGlobal': 'No live streamer is available for global chat',
        'common.close': 'Close',
        'common.remove': 'Remove',
        'common.loading': 'Loading…',
        'common.error': 'Error: {message}',
        'stream.chat': 'Open dedicated chat',
        'stream.focus': 'Focus player',
        'stream.leaveFocus': 'Leave focus mode',
        'stream.maximize': 'Maximize',
        'stream.restore': 'Restore all players',
        'stream.latency': 'Adjust stream latency',
        'stream.waiting': 'Waiting',
        'stream.queue': 'Queue · {count}',
        'stream.spectators': '{count} viewers',
        'stream.added': '{name} was added to your streams',
        'stream.queued': '{name} was added to the queue',
        'stream.alreadyAdded': '{name} is already in your list',
        'stream.removed': '{name} was removed',
        'stream.live': '{name} is now live!',
        'stream.offline': '{name} is offline and has returned to the queue.',
        'stream.searching': 'Searching…',
        'stream.noResults': 'No streamers found',
        'stream.offlineSearch': 'Offline · add to queue',
        'stream.reordered': 'Streamer layout updated',
        'stream.loadError': 'Error loading streamers',
        'stream.addError': 'Could not add the streamer. Please try again.',
        'stream.retrieveError': 'Could not retrieve this streamer',
        'stream.removeError': 'Could not remove the streamer',
        'audio.muted': 'Muted',
        'audio.mute': 'Mute',
        'audio.unmute': 'Unmute',
        'audio.lower': 'Lower volume',
        'audio.raise': 'Raise volume',
        'mini.actions': 'Actions for {name}',
        'chat.welcome': 'Welcome to MultiStream chat',
        'chat.noLive': 'No streamer is currently live.',
        'chat.addHint': 'Add streamers to see their chats here!',
        'chat.clickHint': 'Click the chat icon next to a streamer to open their chat.',
        'chat.individualMode': 'Individual Chat Mode',
        'chat.globalHint': 'Switch to global chat with the globe icon in the sidebar.',
        'welcome.title': 'Welcome to MultiStream',
        'welcome.eyebrow': 'Your Twitch space, together',
        'welcome.heroTitle': 'All your streams.',
        'welcome.heroAccent': 'One screen.',
        'welcome.fast': 'Progressive loading',
        'welcome.shareable': 'Shareable layout',
        'welcome.flexible': 'Independent controls',
        'welcome.live': 'Ready to watch',
        'welcome.audioTitle': 'Audio under control',
        'welcome.audioText': 'Switch sound and focus instantly between your streams.',
        'welcome.subtitle': 'Watch multiple Twitch streams at once in a customizable layout',
        'welcome.multipleTitle': 'Multiple Streams',
        'welcome.multipleText': 'Watch your favorite streamers simultaneously in a customizable grid.',
        'welcome.shareTitle': 'Easy Sharing',
        'welcome.shareText': 'Share your stream layout with a simple URL.',
        'welcome.combosTitle': 'Stream Combos',
        'welcome.combosText': 'Create, save and load your favorite stream combinations.',
        'welcome.search': 'Search Streamer',
        'welcome.resume': 'Resume Streams',
        'welcome.browse': 'Browse Combos',
        'welcome.discord': 'Join Discord',
        'welcome.featured': 'Featured Stream Combos',
        'welcome.yours': 'Your Stream Combos',
        'welcome.manage': 'Manage',
        'welcome.sidebarIntro': 'Search for a Twitch streamer above to add them to your layout.',
        'welcome.sidebarShare': 'Watch multiple streamers at once and easily share your layout.',
        'welcome.examples': 'Example URLs:',
        'welcome.noCombos': 'You have not created any stream combos yet.',
        'welcome.createFirst': 'Create Your First Combo',
        'latency.title': 'Adjust stream latency',
        'latency.description': 'Configure a custom delay to synchronize this stream with the others.',
        'latency.delay': 'Delay (seconds):',
        'latency.none': 'No delay',
        'latency.preview': 'The stream will be delayed by {seconds} seconds',
        'latency.previewPrefix': 'The stream will be delayed by',
        'latency.seconds': 'seconds',
        'latency.reset': 'Reset',
        'latency.apply': 'Apply',
        'latency.applied': 'A {seconds}s delay was applied to the stream',
        'latency.removed': 'Stream delay removed',
    },
} as const;

function detectLanguage(): InterfaceLanguage {
    let saved: string | null = null;
    try {
        saved = localStorage.getItem(STORAGE_KEY);
    } catch {
        // La langue du navigateur reste disponible si le stockage est bloqué.
    }
    if (saved === 'fr' || saved === 'en') return saved;
    const browserLanguage = navigator.languages?.[0] || navigator.language || 'en';
    return browserLanguage.toLowerCase().startsWith('fr') ? 'fr' : 'en';
}

let currentLanguage: InterfaceLanguage = detectLanguage();

export function getLanguage(): InterfaceLanguage {
    return currentLanguage;
}

export function t(key: keyof typeof translations.en, values: Record<string, string | number> = {}): string {
    let value: string = translations[currentLanguage][key] || translations.en[key] || key;
    Object.entries(values).forEach(([name, replacement]) => {
        value = value.replaceAll(`{${name}}`, String(replacement));
    });
    return value;
}

export function applyTranslations(root: ParentNode = document): void {
    root.querySelectorAll<HTMLElement>('[data-i18n]').forEach(element => {
        element.textContent = t(element.dataset.i18n as keyof typeof translations.en);
    });
    const translatedAttributes = {
        placeholder: 'i18nPlaceholder',
        title: 'i18nTitle',
        'aria-label': 'i18nAriaLabel',
    } as const;
    Object.entries(translatedAttributes).forEach(([attribute, datasetKey]) => {
        root.querySelectorAll<HTMLElement>(`[data-i18n-${attribute}]`).forEach(element => {
            const key = element.dataset[datasetKey];
            if (key) element.setAttribute(attribute, t(key as keyof typeof translations.en));
        });
    });
}

export function setLanguage(language: string): void {
    currentLanguage = language === 'fr' ? 'fr' : 'en';
    try {
        localStorage.setItem(STORAGE_KEY, currentLanguage);
    } catch {
        // Le changement reste actif pour la session courante.
    }
    document.documentElement.lang = currentLanguage;
    document.title = t('app.title');
    applyTranslations();
    window.dispatchEvent(new CustomEvent('interface-language-change', { detail: currentLanguage }));
}

export function initializeI18n(): void {
    document.documentElement.lang = currentLanguage;
    document.title = t('app.title');
    applyTranslations();
    const select = document.querySelector<HTMLSelectElement>('#interface-language');
    if (select) {
        select.value = currentLanguage;
        select.addEventListener('change', () => setLanguage(select.value));
    }
}
